var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 32,
    viewBox: "0 0 101 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1579 0L26.2779 12.48C25.4601 9.39131 23.6289 6.66666 21.0779 4.74286C18.4705 2.7729 15.2943 1.70214 12.0265 1.69143H-0.0078125V30.3314H12.0722C15.3663 30.3912 18.5855 29.345 21.215 27.36C23.7572 25.4194 25.5467 22.6563 26.2779 19.5429L43.1579 32L59.9922 19.5429V30.3314H78.9865V24.5143H66.415V1.65714H59.5579V12.4571L43.5579 24.9257L40.1293 22.0229L47.9007 16.2057L56.1065 9.97714L51.3522 6.24L35.4208 18.2857L31.9922 15.3829L47.9922 3.74857L43.1579 0ZM6.46076 7.48571H11.6379C12.7045 7.48345 13.7597 7.70539 14.735 8.13714C15.7159 8.57449 16.6042 9.19513 17.3522 9.96572C18.1261 10.7654 18.7425 11.7037 19.1693 12.7314C20.0264 14.9052 20.0264 17.3233 19.1693 19.4971C18.7773 20.5257 18.1958 21.4716 17.455 22.2857C16.7275 23.1036 15.8409 23.7647 14.8493 24.2286C13.8182 24.7067 12.6945 24.9525 11.5579 24.9486H6.46076V7.48571ZM100.564 24.5143V30.3314H81.5693V1.66857H88.4836V24.5257H100.564V24.5143Z",
    fill: "#050505",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelllogo);
export default __webpack_public_path__ + "static/media/delllogo.3a0dc930df648b3bef547c7a6628e441.svg";
export { ForwardRef as ReactComponent };